import script from "./ProfileNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileNotification.vue?vue&type=script&setup=true&lang=js"

import "./ProfileNotification.vue?vue&type=style&index=0&id=549958ac&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-549958ac"]])

export default __exports__